import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DeployTime } from 'src/environments/deploytime';
import { LogsService } from '../../services/logs.service';

@Component({
  selector: 'app-permission-error',
  templateUrl: './permission-error.component.html',
  styleUrls: ['./permission-error.component.scss']
})
export class PermissionErrorComponent implements OnInit {
  version: string;
  deployDate: string;

  constructor(private logsService: LogsService) {
    const deployTime = DeployTime.getInstance(this.logsService);
    this.version = deployTime.getLastCommitId();
    this.deployDate = deployTime.getFormattedStartupDate();
  }

  ngOnInit(): void {}
}